<script>
import { Ad } from "@/api";
export default {
  name: "adManager",
  data() {
    return {
      adList: [],
      adFilterData: {
        PositionName: "search-top",
        WebsiteId: "028357e3-2115-445c-a1a1-df34352c53bb",
        AdNum: 2
      }
    };
  },
  methods: {
    getAdData() {
      this.$api(Ad.QueryAdByPosition, this.adFilterData).then(res => {
        this.adList = res.AdList.sort((a, b) => {
          return b.Weight - a.Weight;
        })
          .map(item => {
            var author = "Talk 工控";
            if (item.ExtendData) {
              if (item.ExtendData.Summary) {
                author = item.ExtendData.Summary;
              }
            }
            return {
              Title: item.Title,
              CoverImage: item.CoverImg,
              Top: false,
              Author: author,
              DisplayTime: item.CreateTime,
              Link: item.Link
            };
          })
          .slice(0, 2);
      });
    },
    clearCache() {
      this.$mdUtils.removeStore(this.localStorageAdCacheKey);
    }
  }
};
</script>

<style>
</style>
